import styled from '@emotion/styled';
import { Button } from '@lightspeed/flame/Button';
import { Card } from '@lightspeed/flame/Card';

export const StyledCard = styled(Card)`
  display: flex;
  align-items: center;
  max-width: 435px;
  min-width: 377px;
  padding: 20px;
  @media screen and (max-width: 1300px) {
    max-width: 377px;
    min-width: 339px;
  }
  @media screen and (max-width: 1260px) {
    max-width: 339px;
    min-width: 250px;
  }
`;

export const StyledButton = styled(Button)`
  width: 170px;
  padding: 5px;
  margin-top: 10px;
`;

export const StyledImg = styled.img`
  width: 114px;
  height: 114px;
  @media screen and (max-width: 1300px) {
    width: 80px;
    height: 80px;
  }
  @media screen and (max-width: 1260px) {
    width: 0px;
  }
`;
